import { Button, Typography } from "@mui/material";
import { usePostHog } from "posthog-js/react";

import { LoadingWrappedNode } from "components/LoadingWrappedNode";
import {
  useStripeCustomerBillingPortal,
  useSubscriptionStatus,
  useWriterComponentState,
} from "hooks";
import { isNonPayingShipperSubscription } from "utils";

import {
  ClientAppEvent,
  SHIPPER_UPGRADE_RELATIVE_URL,
} from "../../../../constants";

interface Props {
  buttonSize?: "small" | "medium" | "large";
  trackingSource: string;
}

export function ShipperUpgradeNowButton(props: Props) {
  const { buttonSize = "medium", trackingSource } = props;
  const { subscription } = useSubscriptionStatus();
  const posthog = usePostHog();
  const { write: postShipperInterest } = useWriterComponentState({
    errorMessage: "",
    writeConfig: {
      method: "post",
      url: "/sales/shipper-premium-interest",
    },
  });

  const { requestCustomerBillingPortalSession, loading } =
    useStripeCustomerBillingPortal({
      onSessionCreatedSuccess: (url) => {
        window.open(url, "_blank");
      },
    });

  const onClick = () => {
    posthog?.capture(ClientAppEvent.SHIPPER_UPGRADE_NOW_BUTTON_CLICKED, {
      source: trackingSource,
      subscription_plan: subscription?.subscription_plan,
    });

    postShipperInterest();

    if (subscription && isNonPayingShipperSubscription(subscription)) {
      // trial and free tier shippers are redirected to the upgrade page
      window.open(SHIPPER_UPGRADE_RELATIVE_URL, "_blank");
    } else {
      // shippers with account upgrade/update sub through stripe customer portal
      requestCustomerBillingPortalSession();
    }
  };

  return (
    <Button
      size={buttonSize}
      variant="contained"
      color="inherit"
      sx={{
        backgroundColor: "yellow",
        backgroundImage: "linear-gradient(to right, #FFFF00, #FFCD01)",
        textTransform: "none",
        // The nav banner squeezes its middle section on narrow screens, which
        // compressed the button until its label broke across two lines.
        flexShrink: 0,
      }}
      onClick={onClick}
    >
      <LoadingWrappedNode loading={loading}>
        <Typography variant="body1" sx={{ color: "black" }} noWrap>
          <b>Upgrade Now</b>
        </Typography>
      </LoadingWrappedNode>
    </Button>
  );
}
